export default __webpack_public_path__ + "static/media/joe-performing.9f37570c.jpg";